module.exports = __webpack_public_path__ + "img/confetti.d896b334.gif";